import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
const baseURL = process.env.VUE_APP_ROOT_API;
axios.defaults.baseURL = baseURL;
Vue.use(VueAxios, axios);
export default VueAxios;